import { Editor } from "@tiptap/core"
import { TextSelection } from "prosemirror-state"

const clearLinkFromDOM = (editor: Editor, linkElement: HTMLAnchorElement) => {
  // Get the position of the link in the document
  const startPos = editor.view.posAtDOM(linkElement, 0)
  const endPos = editor.view.posAtDOM(
    linkElement,
    linkElement.childNodes.length
  )

  // Set the selection to the link range
  const linkRange = TextSelection.create(editor.state.doc, startPos, endPos)
  editor.view.dispatch(editor.state.tr.setSelection(linkRange))

  // Use editor.chain() API to remove the link
  editor.chain().focus().unsetLink().run()
}

const clearPageLinkFromDOM = (
  editor: Editor,
  linkElement: HTMLAnchorElement
) => {
  // Get the position of the link in the document
  const startPos = editor.view.posAtDOM(linkElement, 0)
  const endPos = editor.view.posAtDOM(
    linkElement,
    linkElement.childNodes.length
  )

  // Get the node at this position
  const node = editor.view.state.doc.nodeAt(startPos)

  // Replace node with the text content
  editor.view.dispatch(
    editor.view.state.tr.replaceRangeWith(
      startPos,
      endPos,
      editor.view.state.schema.text(
        "@" + (node?.attrs?.label || "No link label")
      )
    )
  )
}

const updateNodeLabelFromDOM = (
  editor: Editor,
  linkElement: HTMLAnchorElement,
  newText: string
) => {
  // Get the position of the link in the document
  const startPos = editor.view.posAtDOM(linkElement, 0)

  const node = editor.view.state.doc.nodeAt(startPos)

  // Replace node attr 'label' with new text
  editor.view.dispatch(
    editor.view.state.tr.setNodeMarkup(
      startPos,
      undefined,
      Object.assign({}, node?.attrs, { label: newText })
    )
  )
}

export { clearLinkFromDOM, clearPageLinkFromDOM, updateNodeLabelFromDOM }
